import { createApiAction } from '@app/packages/api/utils'
import type { ApiTbankReview, ApiTbankReviewsSummary } from '@app/packages/api/v2/types/entities'
import type { ReviewsPageMeta, TBankReviewRequest } from '@app/packages/api/v2/types/params'
import { v2Path } from '@app/packages/api/v2/utils'

export const getTBankReviewsByQuery = (request: TBankReviewRequest) =>
  createApiAction('getTBankReviewsByQuery', dispatch =>
    dispatch<{ data: ApiTbankReview[]; meta: ReviewsPageMeta }>({ method: 'GET', endpoint: v2Path('/api/v2/t_bank_reviews', request) })
  )

export const getTBankReviewsSummary = () =>
  createApiAction('getTBankReviewsSummary', dispatch =>
    dispatch<{ data: ApiTbankReviewsSummary }>({ method: 'GET', endpoint: '/api/v2/t_bank_reviews/summary' })
  )
